export var getActualSectionPaddingForSmallScreenCss = function (_a) {
    var css = _a.css;
    var hasContentPadding = !!css['so-global-region-logo-content'];
    var customStrippedLogoPaddingConfiguration = hasContentPadding
        ? "\n    .html-email-logo-column-strip-layout > table > tbody > tr > td {\n      padding-right: 0px!important;\n      padding-left: 0px!important;\n    }\n  "
        : '';
    var customLinkPaddingConfiguration = "\n    .section-link-image > table > tbody > tr > td {\n      padding-bottom: 0px!important;\n    }\n\n    .section-link-text > table > tbody > tr > td {\n      padding-top: 24px!important;\n    }\n  ";
    var configurations = customStrippedLogoPaddingConfiguration.concat(customLinkPaddingConfiguration);
    return configurations;
};
//# sourceMappingURL=get-section-padding-tweaks-for-small-screen-css.js.map